
<div class="content-container">
  <router-outlet></router-outlet>
</div>

